export default __webpack_public_path__ + "static/media/phone-pick-job.fee21255.svg";